import { Redirect } from 'react-router';
import { Routes, Route, useLocation } from 'react-router-dom-v5-compat';

import { ProfileFieldsPage } from './fields';
import { EventSummaryPage } from './events';
import { EventHistoryContext as EventHistoryPage } from './events/history';
import { ListDisplay } from './lists';
import { SubscriptionsPage } from './subscriptions';
import { ProfileLayout } from './ProfileLayout';
import { UserMetadataQueryContextProvider } from './contexts/UserMetadataQueryContextProvider';
import { ListsContextProvider } from './contexts/ListsContextProvider';
import { useUserKeyParameter } from './hooks';
import { ConnectedBAXAIProvider } from './ConnectedBAXAIProvider';

export const UserProfilesPage = () => {
  const rawUserKey = useUserKeyParameter();
  const readableUserKey = useUserKeyParameter(true);
  const location = useLocation();
  const redirect = location.pathname.replace(readableUserKey, rawUserKey);
  if (location.pathname !== redirect) {
    return (
      <Redirect
        push={false}
        to={{
          ...location,
          pathname: redirect,
        }}
      />
    );
  }

  return (
    <UserMetadataQueryContextProvider>
      <ListsContextProvider>
        <ConnectedBAXAIProvider>
          <ProfileLayout>
            <Routes>
              <Route path="fields" element={<ProfileFieldsPage />} />
              <Route path="event/summary" element={<EventSummaryPage />} />
              <Route path="event/history" element={<EventHistoryPage />} />
              <Route path="lists" element={<ListDisplay />} />
              <Route path="subscriptions" element={<SubscriptionsPage />} />
              <Route path="/" element={<Redirect to={`${rawUserKey}/fields`} />} />
            </Routes>
          </ProfileLayout>
        </ConnectedBAXAIProvider>
      </ListsContextProvider>
    </UserMetadataQueryContextProvider>
  );
};
